import '../../style/';
import '../../tabs/style/';
import './index.less';
import '../../badge/style/';
